import GenericPage from '../components/generic/GenericPage'
import tiles from '../components/generic/Tiles'

const MapFS = () => {
  return (
    <GenericPage frame="https://rsgiskaznu.maps.arcgis.com/apps/mapviewer/index.html?webmap=21be10ec8e0f45b5a19e23cc1347d3dd" title="Карта функционального зонирования" tiles={tiles.back('map')} frame_offset={60}/>
  )
}
export default MapFS
